import React from "react";
import { Check, BookOpenCheck, FileBadge2, Stamp } from "lucide-react";
import { Button } from "./ui/button";
import { REGISTRO, CONTACT } from "../data/mock";

const BLOCK_ICONS = [BookOpenCheck, FileBadge2, Stamp];

export default function Registro() {
  return (
    <section id="registro" className="relative py-24 md:py-32 bg-gradient-to-b from-[#f5f7ff] to-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="reveal max-w-3xl">
          <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#f59e0b]">
            Albo Professionale
          </div>
          <h2 className="mt-3 text-3xl md:text-5xl font-extrabold text-[#0a1f55] leading-[1.05]">
            {REGISTRO.title}
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">{REGISTRO.intro}</p>
        </div>

        <div className="mt-10 grid lg:grid-cols-3 gap-5">
          {REGISTRO.blocks.map((b, i) => {
            const Icon = BLOCK_ICONS[i] || BookOpenCheck;
            return (
              <div
                key={b.heading}
                className="reveal rounded-2xl border border-slate-200 bg-white p-6 lift"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <div className="h-10 w-10 rounded-lg bg-[#102a6b]/10 text-[#102a6b] flex items-center justify-center">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="mt-4 text-lg font-bold text-[#0a1f55]">{b.heading}</h3>
                {b.price && (
                  <div className="mt-1 text-2xl font-extrabold text-[#102a6b]">{b.price}</div>
                )}
                <p className="mt-2 text-[13.5px] text-slate-600 leading-relaxed">{b.subheading}</p>
                <ul className="mt-4 space-y-2.5">
                  {b.items.map((it) => (
                    <li key={it} className="flex items-start gap-2 text-[13.5px] text-slate-700">
                      <Check className="h-4 w-4 mt-0.5 text-[#102a6b] shrink-0" />
                      <span>{it}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        {/* Benefits panel */}
        <div className="mt-10 reveal rounded-3xl bg-[#0a1f55] text-white p-8 md:p-12 relative overflow-hidden">
          <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-[#f59e0b]/25 blur-3xl"></div>
          <div className="relative grid lg:grid-cols-12 gap-8">
            <div className="lg:col-span-5">
              <h3 className="text-2xl md:text-3xl font-extrabold leading-tight">
                Essere iscritti al <span className="text-[#f59e0b]">Registro ACDT</span>
              </h3>
              <p className="mt-4 text-slate-300 leading-relaxed">
                Una rete qualificata di consulenti ed educatori riconosciuti, con strumenti operativi,
                aggiornamento permanente e visibilità professionale.
              </p>
              <a href={CONTACT.iscrizione} target="_blank" rel="noreferrer">
                <Button className="mt-6 bg-[#f59e0b] hover:bg-[#d97706] text-[#0a1f55] font-bold">
                  Richiedi l'iscrizione al Registro
                </Button>
              </a>
            </div>
            <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
              {REGISTRO.benefits.map((b) => (
                <div key={b} className="flex items-start gap-3 rounded-xl bg-white/[0.05] border border-white/10 p-4">
                  <div className="h-7 w-7 rounded-md bg-[#f59e0b] text-[#0a1f55] flex items-center justify-center shrink-0">
                    <Check className="h-4 w-4" />
                  </div>
                  <p className="text-[13.5px] text-slate-200 leading-relaxed">{b}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
